<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-form-item label="Activity Date">
          <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="['tanggal', {
            rules: [{ required: true }],
            initialValue: (tanggal ? moment(tanggal, getDefaultDateFormat) : null)
          }]" />
        </a-form-item>
        <a-form-item label="TLC">
          <a-select mode="multiple"
            v-decorator="['pelaksana', { rules: [{ required: true }], initialValue: collectData.informasi.assignee }]">
            <a-select-option v-for="(data) in collectData.informasi.assignee" :key="data">{{ data }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Region">
          <a-radio-group
            v-decorator="[
              'tipe',
              {
                rules: [{ required: true }],
                initialValue: collectData.informasi.tipe?collectData.informasi.tipe:'DN',
              },
            ]"
            button-style="solid"
          >
            <a-radio-button value="DN"> Dalam Negeri </a-radio-button>
            <a-radio-button value="LN"> Luar Negeri </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="Activity">
          <a-input autocomplete="off" v-decorator="['kegiatan', { rules: [{ required: true }] }]"></a-input>
        </a-form-item>
        <a-form-item label="Result">
          <a-textarea
            v-decorator="['hasil', { rules: [{ required: true }], initialValue: initialData.hasil }]"></a-textarea>
        </a-form-item>
        <div>
          <a-divider class="margin-bottom-small">or</a-divider>
          <div>
            <h4>Upload Excel File</h4>
            <p>
              If You Don't Have a File Upload Template Please Click
              <a-button class="padding-remove" type="link" @click="handleDownload">Download Template</a-button>
            </p>
            <a-upload accept=".xls, .xlsx" :showUploadList="true" :fileList="push" :beforeUpload="beforeUpload"
              :remove="handleRemoveupload" v-decorator="['upload', { valuePropName: 'push' }]">
              <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
            <a-divider v-if="getScreen"></a-divider>
          </div>
        </div>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button @click="handleNewItem" block type="primary" :loading="loading.add" html-type="submit"
            class="margin-top">Add</a-button>
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div slot="header">
              <h4 class="margin-remove">Activity List</h4>
            </div>
            <a-list itemLayout="vertical" :dataSource="listKegiatan" :pagination="pagination">
              <Empty v-if="listKegiatan ? listKegiatan.length <= 0 : listKegiatan" />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title" class="m-display-flex space-between">
                    <span >{{ moment(item.values.tanggal).format(getDefaultDateFormat) }}</span>
                    <a-tag v-if="item.values.tipe === 'LN'" color="red"
                      >{{ 'Luar Negeri' }}</a-tag>
                    <a-tag v-else color="green"
                      >{{ 'Dalam Negeri' }}</a-tag>
                  </div>
                  <div slot="description" class="margin-remove">
                    <div class="m-display-flex">
                      <span>{{ item.values.pelaksana }}</span>
                    </div>
                    <div class="m-display-flex">
                      <span>{{ item.values.kegiatan }}</span>
                    </div>
                    <!--  <a-divider class="margin-small" /> -->
                    <div class="m-display-flex">
                      <span>{{ item.values.hasil }}</span>
                    </div>
                  </div>
                </a-list-item-meta>
                <a-button-group>
                  <a-button @click="handleEditModal(item)" type="primary">
                    <a-icon type="edit" />&nbsp;Change
                  </a-button>
                  <a-button @click="handleRemove(item.values.id_pdlk_dtl)" type="danger" icon="close"
                    :loading="loading.delete && loading.key == item.values.id_pdlk_dtl">
                    &nbsp;Delete
                  </a-button>
                </a-button-group>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
    <a-modal v-model="editModal" v-if="editModal" :footer="null">
      <span slot="title">
        <a-icon type="reload" />&nbsp;Change Activity
      </span>

      <a-form :form="modalForm">
        <a-form-item label="Tanggal Kegiatan">
          <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="['tanggal', {
            rules: [{ required: true }],
            initialValue: moment(editData.tanggal, getDefaultDateFormat)
          }]" />
        </a-form-item>
        <a-form-item label="TLC">
          <a-select mode="multiple"
            v-decorator="['pelaksana', { rules: [{ required: true }], initialValue: texttoArray(editData.values.pelaksana) }]">
            <a-select-option v-for="(data) in collectData.informasi.assignee" :key="data">{{ data }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Region">
          <a-radio-group
            v-decorator="[
              'tipe',
              {
                rules: [{ required: true }],
                initialValue: editData.values.tipe,
              },
            ]"
            button-style="solid"
          >
            <a-radio-button value="DN"> Dalam Negeri </a-radio-button>
            <a-radio-button value="LN"> Luar Negeri </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="Activity">
          <a-input autocomplete="off" v-decorator="['kegiatan', {
            rules: [{ required: true }],
            initialValue: editData.values.kegiatan
          }]"></a-input>
        </a-form-item>
        <a-form-item label="Note">
          <a-textarea
            v-decorator="['hasil', { rules: [{ required: true }], initialValue: editData.values.hasil }]"></a-textarea>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button @click="handleModalEdit" block type="danger" :loading="loading.edit"
            html-type="submit">Change</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod";
import _ from "lodash";

export default {
  name: "DetailKegiatan",
  mixins: [CurrencyFormat, GlobalMethod],
  props: {
    listKegiatan: {},
    collectData: {},
    mode: String,
    id_pdlk: String,
  },
  data() {
    return {
      editModal: false,
      pagination: {
        onChange: (page) => { },
        pageSize: 5,
        size: "small",
      },
      satuan: [],
      editData: [],
      tanggal: null, //moment().utc(true),
      loading: {
        key: "",
        add: false,
        delete: false,
      },
      push: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getDefaultDateFormat", "getStandartFormatDate", "getScreen", "getSatuan", "getAuth"]),
    initialData() {
      if (this.listKegiatan === undefined || this.listKegiatan.length <= 0) {
        return {
          tanggal: "",
          kegiatan: "",
          hasil: "",
        };
      } else {
        return {
          tanggal: this.listKegiatan.tanggal,
          kegiatan: this.listKegiatan.kegiatan,
          hasil: this.listKegiatan.hasil,
        };
      }
    },
    initialList() {
      let outputList = [];
      if (this.listKegiatan.length >= 1) {
        outputList = this.listKegiatan;
      }

      return outputList;
    },
  },
  methods: {
    moment,
    handleRef() {
      if (this.listKegiatan.length <= 0) {
        this.displayMessage("form-moreData");
      } else {
        Event.$emit("informasi", { listKegiatan: this.listKegiatan });
      }
    },
    handleNewItem() {
      if (this.push.length > 0) {
        let addData = new FormData();
        this.push.forEach((file) => {
          addData.append("file_upload", file);
        });
        if (this.listKegiatan.length > 0)
          addData.append("id_pdlk", this.listKegiatan[0].values.id_pdlk_fk);
        addData.append("id_sppd", this.collectData.informasi.id_sppd);
        addData.append("tgl_buat", this.collectData.informasi.tgl_buat);
        addData.append("lokasi", this.collectData.informasi.lokasi);
        this.postUpload(addData);
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }
          /* let valuesItem =  {
              keyIndex: 1,
              tanggal: values.tanggal,
              kegiatan: values.kegiatan,
              hasil: values.hasil,
            }; */

          const findName = this.listKegiatan.filter(
            (item) =>
              moment(item.values.tanggal).format(this.getDefaultDateFormat) ===
              moment(values.tanggal).format(this.getDefaultDateFormat) &&
              item.values.kegiatan === values.kegiatan
          );

          if (findName.length > 0) {
            this.displayMessage("form-duplicate");
            return;
          } else {
            let data = new FormData();
            if (this.listKegiatan.length > 0)
              data.append("id_pdlk", this.listKegiatan[0].values.id_pdlk_fk);
            data.append("id_sppd", this.collectData.informasi.id_sppd);
            data.append("tgl_buat", this.collectData.informasi.tgl_buat);
            data.append("lokasi", this.collectData.informasi.lokasi);
            data.append("tanggal", moment(values.tanggal).format(this.getStandartFormatDate));
            data.append("kegiatan", values.kegiatan);
            data.append("hasil", values.hasil);
            data.append("pelaksana", this.arraytoText(values.pelaksana));
            data.append("tipe", values.tipe);

            this.loading.add = true;
            this.asyncAxiosPost("lap_kegiatan_pd/dtl_pdlk", "formdata", this.getAuth, data)
              .then((response) => {
                let values = response.dtl[0];
                Event.$emit("listKegiatan", { values: values, id_pdlk: response.id_pdlk });
                Event.$emit("updateIdpdlk", { id_pdlk: response.id_pdlk });

                this.loading.add = false;
                this.form.resetFields();
              })
              .catch(() => {
                this.loading.add = false;
                this.loading.cancel = false;
              });
          }
        });
      }
    },
    handleRemove(id) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.delete = true;
          that.loading.key = id;
          that.asyncAxiosDelete(
            "lap_kegiatan_pd/dtl_pdlk",
            "application/json",
            that.getAuth,
            { id_pdlk_dtl: id }
          )
            .then((response) => {
              const newPush = that.listKegiatan.filter(
                (item) =>
                  item.values.id_pdlk_dtl != id
              );
              Event.$emit("updateList", newPush);
              that.loading.delete = false;
              that.loading.key = "";
            })
            .catch((err) => {
              console.log(err);
              that.loading.delete = false;
              that.loading.key = "";
            });
        },
        onCancel() { },
      })
    },
    handleEditModal(items) {
      const itemSent = {
        ...items,
        tanggal: moment(items.values.tanggal).format(this.getDefaultDateFormat),
      };
      this.editData = itemSent;
      this.editModal = !this.editModal;
    },
    handleModalEdit() {
      this.modalForm.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading.edit = true;

        let paramdata = {
          id_pdlk_dtl: this.editData.values.id_pdlk_dtl,
          tanggal: moment(values.tanggal).format(this.getStandartFormatDate),
          kegiatan: values.kegiatan,
          hasil: values.hasil,
          pelaksana: this.arraytoText(values.pelaksana),
          tipe: values.tipe
        }

        this.asyncAxiosPut("lap_kegiatan_pd/dtl_pdlk", "application/json", this.getAuth, paramdata)
          .then((response) => {
            let newData = this.listKegiatan;
            let indx = _.findIndex(newData, (e) => {
              return e.values.id_pdlk_dtl == this.editData.values.id_pdlk_dtl;
            });

            let newData2 = newData[indx]
            newData2.values.pelaksana = this.arraytoText(values.pelaksana);
            newData2.values.kegiatan = values.kegiatan;
            newData2.values.tipe = values.tipe;
            newData2.values.tanggal = moment(values.tanggal).format(this.getStandartFormatDate);
            newData2.values.hasil = values.hasil;

            newData.splice(indx, 1, newData2);

            Event.$emit("updateList", newData);
            Event.$emit("updateIdpdlk", { id_pdlk: response.id_pdlk });
            this.editModal = !this.editModal;
            this.editData = [];

            this.displayMessage("success-edit");
            this.loading.edit = false;
          })
          .catch((err) => {
            console.log(err)
            this.editData = [];
            this.loading.edit = false;
          });
      });
    },
    arraytoText(array) {
      let text = ""
      array.forEach((element) => {
        text += (text == "" ? element : "," + element);
      });
      return text;
    },
    texttoArray(text) {
      return text.split(",")
    },
    handleDownload() {
      this.asyncAxiosGet(
        "/main/download_template_lkpd",
        this.getAuth,
        {}
      )
        .then((response) => {
          window.open(this.$serviceUrl + response.url, "_blank");
        })
        .catch(() => {
          this.displayMessage("error-emptyDocTemplate");
        });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
    },
    handleRemoveupload() {
      this.push = [];
    },
    postUpload(data) {
      this.loading.add = true;
      this.asyncAxiosPost("lap_kegiatan_pd/upload_template", "formdata", this.getAuth, data)
        .then((response) => {
          this.push = [];
          if (this.mode === "Create") {
            this.displayMessage("success-add");
          } else {
            this.displayMessage("success-edit");
          }

          let newData = []
          let values = []
          for (let index = 0; index < response.dtl.length; index++) {
            values = { values: response.dtl[index] }
            newData.push(values)
          }
          Event.$emit("updateList", newData);
          this.loading.add = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading.add = false;
        });
    },
  },
};
</script>

<style></style>